import { BusinessEntity } from 'src/modules/shared/models/business-entity.model';

export class SaveLegalEntityInformation {
  static readonly type = '[Legal Entity Information] Save';

  constructor(
    public businessEntity: BusinessEntity
  ) {}
}
